import { FC } from 'react';
import { getTargetGroupById } from '../../../businessLogicService/getStudentsInRoadmap';
import { splitId } from '../../../businessLogicService/splitIdsFromBackEnd';
import ProgressTooltip from '../ProgressTooltip';
import { StudentNameLink } from '../../common/StudentNameLink/StudentNameLink';
import { useAppSelector } from '../../../redux/hooks';
import { selectedReportsFilter } from '../../../redux/reducers/filterReportsSlice';
import { MaskedStudentData } from '../../MaskedData/MaskedStudentData';
import { PiiTypes } from '../../../analytics/dataMasking';

interface Props {
  studentData: {
    studentId: string;
    studentLastName: string;
    currentRoadmap: string | null;
    currentRoadmapName?: string | null;
    studentPublicUserId: string;
  };
  filterRoadmapId: string;
}

const ProgressColumnName: FC<Props> = ({ studentData, filterRoadmapId }) => {
  const targetGroup = getTargetGroupById(studentData.currentRoadmap!, studentData.currentRoadmapName!, filterRoadmapId);
  const reduxFilters = useAppSelector(selectedReportsFilter);
  return (
    <>
      <div
        className="flex align-items-center justify-content-between"
        style={{ minWidth: '160px', width: '160px', fontFamily: 'Poppins' }}
      >
        <StudentNameLink studentId={studentData.studentId} classIds={reduxFilters.classes.map(cl => cl.id)}>
          <MaskedStudentData student={{ publicUserId: studentData.studentPublicUserId }} type={PiiTypes.LastName}>
            {studentData.studentLastName}
          </MaskedStudentData>
        </StudentNameLink>
        {!targetGroup.matchOrNotApply && (
          <>
            <ProgressTooltip
              data={{
                studentId: studentData.studentId,
                currentRoadmapName: targetGroup?.name as string,
              }}
            />
            <span
              className={`pi pi-exclamation-triangle cursor-pointer exclamation-target-${splitId(
                studentData.studentId,
              )}`}
              style={{ color: '#FDB814' }}
            ></span>
          </>
        )}
      </div>
    </>
  );
};

export default ProgressColumnName;
